import { formatDateToTimezone } from "utils/date"

const dateTagHelper = (msg, startDate, endDate) => {
  return msg.replace(
    "{startDate}",
    formatDateToTimezone(startDate)
  ).replace(
    "{endDate}",
    formatDateToTimezone(endDate)
  )
}

export default dateTagHelper
